export const FileIdentifiersAll = [
  {
    name: 'Acordo de confissão de dívidas',
    key: 'DEBT_CONFESS_AGREEMENT',
  },
  {
    name: 'Acordo escritório',
    key: 'OFFICE_AGREEMENT',
  },
  {
    name: 'Água',
    key: 'WATER_BILL',
  },
  {
    name: 'Apólice seguro fiança',
    key: 'BAIL_INSURANCE_POLICY',
    'required': false
  },
  {
    name: 'Apólice seguro incêndio',
    key: 'FIRE_INSURANCE_POLICY',
  },
  {
    name: 'Boleto aluguel',
    key: 'RENT_BILL',
  },
  {
    name: 'Boleto condomínio',
    key: 'CONDOMINIUM_BILL',
  },
  {
    name: 'Boleto devolutivo',
    key: 'RETURN_BILL',
    'required': false,
  },
  {
    name: 'Carta de encerramento',
    key: 'CLOSING_LETTER',
  },
  {
    name: 'Certidão de óbito',
    key: 'DEATH CERTIFICATE',
  },
  {
    name: 'Comprovante de endereço locador',
    key: 'LOCATOR_ADDRESS_DOCUMENT',
  },
  {
    name: 'Comprovante de pagamento',
    key: 'PAYMENT_VOUCHER',
  },
  {
    name: 'Contrato de administração',
    key: 'PROPERTY_MANAGEMENT_CONTRACT',
  },
  {
    name: 'Contrato de locação',
    key: 'LOCATION_QUOTATION',
  },
  {
    name: 'Contrato Garantti locatário',
    key: 'LOCATOR_GARANTTI_CONTRACT',
  },
  {
    name: 'Declaração de condomínio',
    key: 'CONDOMINIUM_DECLARATION',
    'required': false,
  },
  {
    name: 'Declaração de débitos',
    key: 'DEBITS_SHEET',
  },
  {
    name: 'Documento de identificação do locador',
    key: 'LOCATOR_DOCUMENT',
  },
  {
    name: 'Documento de identificação do locatário',
    key: 'TENANT_DOCUMENT',
  },
  {
    name: 'Endosso de cancelamento',
    key: 'CANCELATION_ENDORSEMENT',
  },
  {
    name: 'Formal de partilha',
    key: 'SHARING_FORM',
  },
  {
    name: 'Guia de IPTU',
    key: 'IPTU_GUIDE',
  },
  {
    name: 'Imissão na posse',
    key: 'POSSESSION_IMMISSION',
  },
  {
    name: 'Informativo de sinistro',
    key: 'CLAIM_INFORMATION',
    'required': false,
  },
  {
    name: 'Luz',
    key: 'ENERGY_BILL',
  },
  {
    name: 'Modelo de orçamento',
    key: 'BUDGET_MODEL',
    'required': false,
  },
  {
    name: 'Orçamentos',
    key: 'BUDGETS',
  },
  {
    name: 'Outros',
    key: 'OTHER',
  },
  {
    name: 'Planilha de acordo',
    key: 'ACCORD_WORKSHEET',
  },
  {
    name: 'Planilha de danos',
    key: 'DAMAGE_WORKSHEET',
    'required': false,
  },
  {
    name: 'Planilha de indenização',
    key: 'INDEMNITY_WORKSHEET',
  },
  {
    name: 'Planilha de pintura',
    key: 'PAINTING_WORKSHEET',
    'required': false,
  },
  {
    name: 'Procuração',
    key: 'LETTER_ATTORNEY',
  },
  {
    name: 'Recibo de condomínio',
    key: 'CONDOMINIUM_RECEIPT',
  },
  {
    name: 'Termo de entrega das chaves',
    key: 'TERM_DELIVERY_PROPERTY_KEYS',
  },
  {
    name: 'Termo de inventariante',
    key: 'INVENTORY_TERM',
  },
  {
    name: 'Vistoria final do imóvel',
    key: 'FINAL_INSPECTION_PROPERTY',
  }
];
